export default function Quiz(props) {
  return (
    <svg
      id="Component_28_25"
      data-name="Component 28 – 25"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20.033"
      viewBox="0 0 20 20.033"
      {...props}>
      <path
        id="Path_5768"
        data-name="Path 5768"
        d="M542.9,3.16h-5.981c-.042-.2-.078-.407-.127-.606A5.075,5.075,0,0,0,535.378.123a6.319,6.319,0,0,1-1.858-3.68,6.4,6.4,0,0,1,3.325-6.594,6.441,6.441,0,0,1,9.2,3.721,6.176,6.176,0,0,1-1.437,6.348A5.757,5.757,0,0,0,542.9,3.16Zm-2.435-4.3a.21.21,0,0,0,.02-.05,2.57,2.57,0,0,0,0-.273,1.4,1.4,0,0,1,.57-1.291,1.715,1.715,0,0,0,.365-2.2,1.736,1.736,0,0,0-2.112-.764,1.865,1.865,0,0,0-1.143,2.22h1.15c0-.21-.008-.405,0-.6a.586.586,0,0,1,.533-.556.585.585,0,0,1,.621.456.591.591,0,0,1-.256.629,2.5,2.5,0,0,0-.882,2.427ZM539.331.049V1.2h1.149V.049Z"
        transform="translate(-529.906 10.924)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5769"
        data-name="Path 5769"
        d="M578.509,183.993h5.871a19.759,19.759,0,0,1-.135,2.5,2.911,2.911,0,0,1-5.722-.243A21.988,21.988,0,0,1,578.509,183.993Z"
        transform="translate(-571.412 -168.722)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5770"
        data-name="Path 5770"
        d="M500.381,16.9l-.918-.918a.537.537,0,0,1,0-.76l.026-.026a.537.537,0,0,1,.759,0l.918.916a.537.537,0,0,1,0,.76l-.026.027A.537.537,0,0,1,500.381,16.9Z"
        transform="translate(-498.436 -13.008)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5771"
        data-name="Path 5771"
        d="M706.644,17.061l-.009-.009a.537.537,0,0,1,0-.759l.924-.923a.537.537,0,0,1,.761,0l.012.012a.536.536,0,0,1,0,.759l-.928.92A.537.537,0,0,1,706.644,17.061Z"
        transform="translate(-689.377 -13.165)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5772"
        data-name="Path 5772"
        d="M501.506,103.21l-.911.911a.537.537,0,0,1-.759,0l-.021-.021a.537.537,0,0,1,0-.759l.911-.911a.537.537,0,0,1,.759,0l.021.021A.537.537,0,0,1,501.506,103.21Z"
        transform="translate(-498.759 -93.404)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5773"
        data-name="Path 5773"
        d="M706.477,102.524l.009-.009a.537.537,0,0,1,.759,0l.919.921a.537.537,0,0,1,0,.759l-.008.008a.537.537,0,0,1-.759,0l-.92-.919A.537.537,0,0,1,706.477,102.524Z"
        transform="translate(-689.23 -93.483)"
        fill="#f7f7f7"
      />
      <rect
        id="Rectangle_977"
        data-name="Rectangle 977"
        width="2.361"
        height="1.157"
        rx="0.578"
        transform="translate(0 5.884)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5774"
        data-name="Path 5774"
        d="M715.695,65.4a.7.7,0,0,1-.081.01H713.87a.537.537,0,0,1-.537-.537v-.087a.537.537,0,0,1,.537-.537h1.287a.537.537,0,0,1,.537.537Z"
        transform="translate(-695.695 -58.356)"
        fill="#f7f7f7"
      />
    </svg>
  );
}
